import { Component, ErrorHandler, OnInit, } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import swal from 'sweetalert2';
@Component({
  selector: 'app-against-notification-form2',
  templateUrl: './against-notification-form2.component.html',
  styleUrls: ['./against-notification-form2.component.css']
})
export class AgainstNotificationForm2Component implements OnInit {
app: any = {};
  formInvalid = false;
  isLoading = false;
  data: any;
  Districts: any;
  listDistrict: any;
  District: any;
  Districtlist: any;
  Districtlists: any;
  App_Reg_No: any;
  appRegNo: any;
  r:any={};

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.app.APP_IsJoint = 'N';
  }

  ngOnInit() {
    this.GetAllDistrict();
     this.GetAllDistrictforApplicant();
     this.GetAllDistrictforcoApplicant();
     this.GetAllDistrictforcoApplicantpermanent();
     this.GetAllDistrictforcoApplicantcorrespondence();
     this.route.queryParams.subscribe(params => {
     this.App_Reg_No = params['App_Reg_No'];
      // ← Guard: block forward-button replay
  if (!this.App_Reg_No || !sessionStorage.getItem('step1Completed')) {
    this.router.navigate(['/applicant-register']);
    return;
  }
  sessionStorage.removeItem('step1Completed');  // ← consume flag
    //this.App_Reg_No = params['App_Reg_No'];
     this.app.APP_IsJoint = params['IsJoint'];
    console.log('Received App No:', this.App_Reg_No);

    // assign to your model
    this.app.App_Reg_No = this.App_Reg_No;
    this.GetByIdVerifyaddressdetails();
  });

  }
    GetByIdVerifyaddressdetails() {
      debugger;

      document.getElementById('loader-spinner').style.display = "block";

      this.userService.GetByIdverificationAddressdetails(this.App_Reg_No)
        .subscribe(
          (response: any) => {

            console.log("Full API Response:", response);

            // ✅ assign actual data
            this.r = response.data;
            this.app = {};
            console.log(this.r);

            this.app.APP_FS_Village = this.r.APP_FS_Village;
            this.app.APP_FS_Post_Office = this.r.APP_FS_Post_Office;
            this.app.App_FS_Police_Station = this.r.APP_FS_Police_Station;
            this.app.APP_FS_District_Fk = this.r.APP_FS_District_Fk;
            this.app.APP_FS_Zipcode = this.r.APP_FS_Zipcode;
            this.app.APP_VI_Name = this.r.APP_VI_Name;
            this.app.Post_office_Co = this.r.Post_office_Co;
            this.app.Police_Station_Co = this.r.Police_Station_Co;
            this.app.APP_DI_Id_FK = this.r.APP_DI_Id_FK;
            this.app.APP_Pincode = this.r.APP_Pincode;
            this.app.APP_IsJoint = this.r.APP_IsJoint;


            if (this.app.APP_IsJoint = 'Y') {
              this.app.Co_APP_FS_Village = this.r.Co_APP_FS_Village;

              this.app.APP_IsJoint = this.r.APP_IsJoint;
              this.app.Co_APP_FS_Post_Office = this.r.Co_APP_FS_Post_Office;
              this.app.Co_App_FS_Police_Station = this.r.Co_App_FS_Police_Station;
              this.app.Co_APP_FS_District_Fk = this.r.Co_APP_FS_District_Fk;
              this.app.Co_APP_FS_Zipcode = this.r.Co_APP_FS_Zipcode;
              this.app.Sec_APP_Village_PERM = this.r.Sec_APP_Village_PERM;
              this.app.Sec_APP_Post_Office_PERM = this.r.Sec_APP_Post_Office_PERM;
              this.app.Sec_App_Police_Station_PERM = this.r.Sec_App_Police_Station_PERM;
              this.app.Sec_APP_District_Fk_PERM = this.r.Sec_APP_District_Fk_PERM;
              this.app.Sec_APP_Zipcode_PERM = this.r.Sec_APP_Zipcode_PERM;
              this.app.Sec_APP_Village_Co = this.r.Sec_APP_Village_Co;
              this.app.Sec_APP_Post_Office_Co = this.r.Sec_APP_Post_Office_Co;
              this.app.Sec_App_Police_Station_Co = this.r.Sec_App_Police_Station_Co;
              this.app.Sec_APP_District_Fk_Co = this.r.Sec_APP_District_Fk_Co;
              this.app.Sec_APP_Zipcode_Co = this.r.Sec_APP_Zipcode_Co;



            }


            document.getElementById('loader-spinner').style.display = "none";
          },
          (error) => {
            console.error(error);
            document.getElementById('loader-spinner').style.display = "none";
          }
        );
    }



  
  copyCoApplicantPermanentAddress(checked: boolean) {
    if (checked) {
      this.app.Sec_APP_Village_Co = this.app.Sec_APP_Village_PERM;
      this.app.Sec_APP_Post_Office_Co = this.app.Sec_APP_Post_Office_PERM;
      this.app.Sec_App_Police_Station_Co = this.app.Sec_App_Police_Station_PERM;
      this.app.Sec_APP_District_Fk_Co = this.app.Sec_APP_District_Fk_PERM;
      this.app.Sec_APP_Zipcode_Co = this.app.Sec_APP_Zipcode_PERM;
    } else {
      this.app.Sec_APP_Village_Co = '';
      this.app.Sec_APP_Post_Office_Co = '';
      this.app.Sec_App_Police_Station_Co = '';
      this.app.Sec_APP_District_Fk_Co = '';
      this.app.Sec_APP_Zipcode_Co = '';
    }
  }
 SaveApplicationstep2(form: NgForm) {

  if (form.invalid) {
    this.formInvalid = true;
    return;
  }
 this.app.App_Reg_No = this.App_Reg_No;
  this.formInvalid = false;
  this.isLoading = true;

  this.userService
    .Step2_SaveAddressDetails(this.app)
    .subscribe({
      next: (res: any) => {
        this.isLoading = false;

        swal('Success!', 'Address Details are Saved Successfully, Please Continue with Step3', 'success');
        sessionStorage.setItem('step2Completed', '1');  // ← add this

        // Navigate to next step page
      this.router.navigate(
  ['/against-notification-form3'],
  { 
    queryParams: { 
       App_Reg_No: res.App_Reg_No  
       
    } 
  }
);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error saving data', err);
        alert('Something went wrong!');
      }
    });
}


  GetAllDistrict() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforform();
    this.data.subscribe(
      (response: any) => {
        this.Districts = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllDistrictforApplicant() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforApplicant();
    this.data.subscribe(
      (response: any) => {
        this.listDistrict = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
    GetAllDistrictforcoApplicant() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicant();
    this.data.subscribe(
      (response: any) => {
        this.District = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
    GetAllDistrictforcoApplicantpermanent() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicantpermanent();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
    GetAllDistrictforcoApplicantcorrespondence() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforcoApplicantcorrespondence();
    this.data.subscribe(
      (response: any) => {
        this.Districtlists = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/against-notification-form2/against-notification-form2.component.ts